import { render, staticRenderFns } from "./DeviceRatingReviews.vue?vue&type=template&id=30fa02c4"
import script from "./DeviceRatingReviews.vue?vue&type=script&lang=js"
export * from "./DeviceRatingReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports